'use client';

import FilterableListbox from "./FilterableListbox";
import { FilterableListItem } from './FilterableListbox-utils';

interface FilterElementProps {
    label: string,
    options: FilterableListItem[],
    value: string,
    onChange: (value: string) => void,
    name?: string,
    hideFilter?: boolean,
    disabled?: boolean,
}

export default function FilterElement({ label, options, value, onChange, name = "", disabled = false, hideFilter = false }: FilterElementProps) {
    return (
        <div className="flex flex-col w-64">
            <strong className="text-left mb-1">{label}</strong>
            <FilterableListbox
                name={name}
                options={options}
                value={value}
                disabled={disabled}
                hideFilter={hideFilter}
                onChange={onChange}
            />
        </div>
    );
}